import { useHomeBanner, useBusinessPartnerItem, useBusinessPartnerCategories } from '@/src/api/getData';
import Banner from '@/components/banner';

const businessPartnerView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: businessPartnerItemData } = useBusinessPartnerItem(language);
    const { data: businessPartnerCategoriesData } = useBusinessPartnerCategories();
    let businessPartnerCategories = businessPartnerCategoriesData?.data || [];
    let businessPartnerLogo = businessPartnerItemData?.data?.Partner || [];

    return (
        <main className='theme-normal format-normalEditor'>
            <Banner banner={banner} category="Business Partner" />
            <section className="contact-details container" id="start">
                {businessPartnerCategories && businessPartnerCategories.length > 0 && (
                    <>
                        {businessPartnerCategories?.map((category: any, index: number) => (
                            <div key={index} className="partner-item">
                                <h2>{language === 'en' ? category?.En_title : category?.Zh_title}</h2>
                                <div className={`logo-group grid grid-cols-2 md:grid-cols-4 lg:grid-cols-${category?.Columns} gap-7`}>
                                    {businessPartnerLogo?.map((partnerItem: any, partnerIndex: number) => (
                                        partnerItem?.Partner_category?.code === category.code && (
                                            <div key={partnerIndex} className="partner-logo">
                                                {partnerItem.Logo == null ? (
                                                    <div className='text'>{language === 'en' ? partnerItem?.EnName : partnerItem?.ZhName}</div>
                                                ) : (
                                                    <div className='icon'>
                                                        {partnerItem.Link == null ? (
                                                            <img src={partnerItem.Logo?.url} alt={language === 'en' ? partnerItem?.EnName : partnerItem?.ZhName} />
                                                        ) : (
                                                            <a href={partnerItem.Link} target="_blank" rel="noopener noreferrer"><img src={partnerItem.Logo?.url} alt={language === 'en' ? partnerItem?.EnName : partnerItem?.ZhName} /></a>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>
                        ))}
                    </>
                )}
            </section>
        </main>
    );
}

export default businessPartnerView;